


export const CONSTANTES = {
  FECHA_CAMPANIA: "18/05/2026"
};